import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.form`
  display: grid;
  margin-top: 40px;
  grid-template-columns: 1fr 1fr 140px 140px;
  column-gap: 20px;
  row-gap: 20px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  p {
    text-transform: uppercase;
    font-size: 13px;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 10px;
    font-weight: 900;
    @media (max-width: ${defaultBreakpoints.medium}) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
  .catagory_item {
    margin-left: 21px;
    @media (max-width: ${defaultBreakpoints.medium}) {
      font-size: 16px;
    }
    :hover {
      cursor: pointer;
      color: ${({ theme }) => theme.default.color.primary};
    }
  }
  .category_wrapper {
    padding-bottom: 13px;
    padding-top: 13px;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    flex-direction: column;
  }
`;
